import React, { useContext, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';



const CnpBestclipPopup = () => {

  const {
    loggedInUser,
    cnpText, setCnpText,
    cnpSelectedLocation, setCnpSelectedLocation,
    setShowCnpLocationPopup,
    cnpSelectedPhotoVideo, setCnpSelectedPhotoVideo,
    setShowCnpTagPopup,
    setCnpTagAxis,
    cnpSelectedMusic,
    selectedMusicPlaying,
    setShowCnpSelectMusicPopup,
    getMusics,
    cnpMusics,
    setSelectedMusicPlaying,
    setCnpSelectedMusic,
    setShowCnpFeelingActivityPopup,
    setCnpFeelingActivityTab,
    getActivities,
    getFeelings,
    createNewPost,
    setShowCreateNewPostPopup,
    setCnpPreviouslyOpenedPopup,
    cnpSelectedFeeling,
    cnpSelectedActivityCategory,
    cnpSelectedActivity,

    // ----- Advance Setting -----
    setShowCnpAdvanceSettingPopup,
    getCnpAdvanceSetting,

    showCnpBestclipPopup, setShowCnpBestclipPopup,
  } = useContext(ApiContext);


  // ----- Bestclip -----

  const bestcilpRef = useRef(null);

  // handle click flix
  const handleClickFlix = () => {
    bestcilpRef.current.click(); 
  };

  // handle flix file change
  const handleFlixFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    const file = files[0];

    // console.log('file : ', file);

    setCnpSelectedPhotoVideo([{
      file,
      tags: [],
      fileType: file.type.startsWith('image/') ? 'image' : 'video',
    }]);
  };


  // ----- text -----

  // handle text change
  const handleTextChange = (e) => {
    const { value } = e.target;

    setCnpText(value);
  };


  // ----- Feeling/Activity -----

  // handle click feeling/activity
  const handleClickFeelingActivity = () => {

    setShowCnpBestclipPopup(false);
    setShowCnpFeelingActivityPopup(true);
    
    if(cnpSelectedActivityCategory._id) {
      setCnpFeelingActivityTab('activity');

      getActivities(cnpSelectedActivityCategory._id, '', 0);
    } else {
      setCnpFeelingActivityTab('feeling');

      getFeelings('', 0);
    };
  };


  // ----- Music -----

  const musicRef = useRef(new Audio());

  // handle click music
  const handleClickMusic = () => {
    setShowCnpBestclipPopup(false);
    setShowCnpSelectMusicPopup(true);

    getMusics('', cnpMusics.length, 10);
  };

  // handle play/pause music
  const handlePlayPauseMusic = () => {
    if (selectedMusicPlaying) {
      musicRef.current.pause();
      setSelectedMusicPlaying(false);
    } else {
      musicRef.current.src = cnpSelectedMusic.audio;
      musicRef.current.play();
      setSelectedMusicPlaying(true);
    };
  };

  // handle remove music
  const handleRemoveMusic = () => {
    setCnpSelectedMusic({});

    musicRef.current.pause();
    
    setSelectedMusicPlaying(false);

    // show location image if location selected when user remove music
    if(cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };



  // ----- Location -----

  // handle click location
  const handleClickLocation = () => {
    setShowCnpBestclipPopup(false);
    setShowCnpLocationPopup(true);
  };


  const [isVideoMuted, setIsVideoMuted] = useState(false);

  // handle click video mute/unmute
  const handleClickVideoMuteUnmute = () => {
    setIsVideoMuted(!isVideoMuted);
  };


  // ----- Options > Delete/Remove -----
  
  // handle click photo delete icon
  const handleClickPhotoVideoDeleteIcon = () => {
    setCnpSelectedPhotoVideo([]);
  };

  // handle click video play/pause
  const handleClickVideoPlayPause = (e) => {
    const video = e.target;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    };
  };

  // handle click video tag icon
  const handleClickVideoTagIcon = (photoVideoIndex) => {
    setCnpTagAxis({
      index: photoVideoIndex,
      offsetX: '',
      offsetY: '',
    });

    setShowCnpTagPopup(true);
  };

  // handle post bestclip
  const handlePostBestclip = () => {
    createNewPost('bestclip');
  };

  // handle click advance setting
  const handleClickAdvanceSetting = () => {
    setShowCnpBestclipPopup(false);
    setShowCnpAdvanceSettingPopup(true);
    getCnpAdvanceSetting('bestclip');
  };

  // handle close bestclip popup
  const handleCloseBestclipPopup = () => {
    setShowCnpBestclipPopup(false);
    setShowCreateNewPostPopup(true);
    setCnpPreviouslyOpenedPopup('createNewPost');
  };


  return (
    <>
      {
        <Modal show={showCnpBestclipPopup} onHide={handleCloseBestclipPopup} centered backdrop="static" keyboard={false} className="main-modal" >
          <Modal.Header className='mb-3 pt-0' closeButton>
            <h5 className='flex-grow-1 text-center pt-3 mb-0'>Bestclip</h5>
          </Modal.Header>
  
          <Modal.Body className='pt-1'>
            {/* Profile, Name, Feeling, Activity & Check in/Location */}
            <>
              {
                loggedInUser 
                &&
                <div className='d-flex align-items-center gap-3'>
                  {/* Profile */}
                  <img src={loggedInUser.profileImg && loggedInUser.profileImg.imageId && AwsFileUrl+loggedInUser.profileImg.imageId} className='border rounded-circle' style={{ height: '45px', width: '45px' }} alt='profile' />

                  <div>
                    {/* Name, Feeling, Activity & Check in/Location */}
                    <div>
                      {/* Name */}
                      <span className='fs-5'>{loggedInUser.fname} {loggedInUser.lname}</span> {' '}

                      {/* Feeling */}
                      <>
                        {
                          (cnpSelectedFeeling && cnpSelectedFeeling._id)
                          &&
                          <>
                            <span className='text-secondary'>is</span> {' feeling '}
                            {cnpSelectedFeeling.feelingName} {' '}
                            <img src={cnpSelectedFeeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                            {' '}
                          </>
                        }
                      </>

                      {/* Activity */}
                      <>
                        {
                          (cnpSelectedActivityCategory && cnpSelectedActivityCategory._id)
                          &&
                          (cnpSelectedActivity && cnpSelectedActivity._id)
                          &&
                          <>
                            <span className='text-secondary'>is</span> {' '}
                            {cnpSelectedActivityCategory.activityCategoryName} {' '}
                            <img src={cnpSelectedActivityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                            {cnpSelectedActivity.activityName} {' '}
                            <img src={cnpSelectedActivity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                          </>
                        }
                      </>

                      {/* Check in/Location */}
                      <>
                        {
                          (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)
                          &&
                          <>
                            <span className='text-secondary'>at</span> {' '}
                            {cnpSelectedLocation.place.split(" ").slice(0, 5).join(" ")}
                            {cnpSelectedLocation.place.split(" ").length > 5 && "..."}
                          </>
                        }
                      </>
                    </div>

                    {/* Add Location */}
                    <>
                      {
                        (cnpSelectedLocation.place === '' && cnpSelectedLocation.lat === null && cnpSelectedLocation.lng === null)
                        &&
                        <div className='cursor-pointer' onClick={handleClickLocation}>
                          <img src={`/images/icons/location-black.svg`} className='me-1' style={{ height: '15px', width: '15px' }} alt="location" />
                          <span>Add Location</span>
                        </div>
                      }
                    </>
                  </div>
                </div>
              }
            </>

            {/* Options > Play/Pause, Mute/Unmute & Delete */}
            <div className='d-flex justify-content-end gap-3 my-3'>
              {/* Mute/Unmute */}
              <>
                {
                  (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[0].file && cnpSelectedPhotoVideo[0].file.type.includes('video'))
                  &&
                  <div className='bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickVideoMuteUnmute}>
                    <img src={`/images/icons/${isVideoMuted ? 'mute' : 'unmute'}-white.svg`} style={{ height: '17px', width: '17px', cursor: 'pointer' }} alt="tag" />
                  </div>
                }
              </>

              {/* Delete */}
              <div className='bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickPhotoVideoDeleteIcon}>
                <img src="/images/icons/delete-white.svg" style={{ height: '17px', width: '17px', cursor: 'pointer' }} alt="tag" />
              </div>
            </div>

            {/* Click here to add bestclip */}
            <>
              {
                (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length === 0)
                &&
                <div className='border rounded-4 my-3 d-flex flex-column align-items-center justify-content-center gap-1 cursor-pointer bg-light' style={{ height: '200px' }} onClick={handleClickFlix} >
                  <img src={`${BASE_URL_STATIC}/upload.png`} className='mb-2' style={{ height: '50px', width: '50px' }} alt="addGallary" />
                  <span>Upload</span>
                  <small className='text-secondary'>Click here to add bestclip</small>
                  <span className='text-secondary'>(Max 5 min)</span>
                  <input type="file" ref={bestcilpRef} style={{ display: 'none' }} accept="video/*" onChange={handleFlixFileChange} />
                </div>
              }
            </>

            {/* Bestcilp > Video */}
            <>
              {
                (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[0].file && cnpSelectedPhotoVideo[0].file.type.includes('video'))
                &&
                <div className='border text-center rounded-4 bg-light' style={{ height: '200px' }}>
                  <div className='d-inline-block position-relative h-100'>
                    <>
                      <video 
                        src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} 
                        className='rounded-0'
                        onClick={handleClickVideoPlayPause} 
                        muted={isVideoMuted} 
                        loop 
                      />

                      {/* Tag Icon */}
                      <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={() => handleClickVideoTagIcon(0)}>
                        <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                      </div>
                    </>
                  </div>
                </div>
              }
            </>

            {/* Music text (jb music selected h lekin music image show nhi krna h tb ye show krna h) */}
            <>
              {
                (cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '')
                &&
                <div className='my-3 d-flex align-items-center gap-3'>
                  <img src="/images/icons/music.svg" style={{ height: '17px', width: '17px' }} alt="music" />
  
                  <span className='me-auto text-truncate'>{cnpSelectedMusic.name}</span>
  
                  {/* Play/Pause */}
                  <img src={selectedMusicPlaying ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} 
                    className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handlePlayPauseMusic} alt='playPause'
                  />
  
                  {/* Remove */}
                  <img src="/images/icons/close-circle.svg" className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handleRemoveMusic} alt="remove" />
                </div>
              }
            </>
  
            {/* text */}
            <textarea className="form-control rounded-4 my-3" name="text" style={{ resize: 'none' }} rows={3} 
              value={cnpText} onChange={handleTextChange} placeholder={`What's new ${loggedInUser && loggedInUser.fname}..?`}
            />
  
            {/* Menu */}
            <div className='d-flex flex-wrap gap-4'>
              <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickFeelingActivity}>
                <img src={`${BASE_URL_STATIC}/create-icon8.png`} style={{ height: '23px', width: '23px' }} alt="feeling/activity" />
                <small className="text-secondary">Feeling/Activity</small>
              </div>
  
              <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickLocation}>
                <img src={`${BASE_URL_STATIC}/create-icon9.png`} style={{ height: '23px', width: '23px' }} alt="Check In" />
                <small className="text-secondary">Check In</small>
              </div>
  
              <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickMusic}>
                <img src={`${BASE_URL_STATIC}/create-icon11.png`} style={{ height: '23px', width: '23px' }} alt="Music" />
                <small className="text-secondary">Music</small>
              </div>
            </div>
  
            <button type="button" className='btn btn-primary w-100 rounded-pill mt-3 mb-1' onClick={handlePostBestclip}
              disabled={cnpSelectedPhotoVideo.length === 0}
            >Post</button>

            {/* Advance Setting */}
            <div className='text-center'>
              <span className='text-primary cursor-pointer' onClick={handleClickAdvanceSetting}>Advance Setting</span>
            </div>
          </Modal.Body>
        </Modal>
      }
    </>
  );
};

export default CnpBestclipPopup;